module.exports = __webpack_public_path__ + "static/media/share-square.a4f5b0f3.svg";